enum ViewActions {
  FREE,
  EVENT_STATE,
  CONDITION_STATE,
  ACTION_STATE,
  FRAUD_STATE,
  NOT_FRAUD_STATE,
  SUSPICIOUS_STATE,
}

export default ViewActions;
